"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Logging = {
    captureMessage: function () { },
    captureException: function () { },
    addBreadcrumb: function () { },
    getCorrelationId: function () {
        return undefined;
    },
    getSessionId: function () {
        return undefined;
    },
    getRelease: function () {
        return undefined;
    },
    getAppId: function () {
        return undefined;
    },
    getDeviceId: function () {
        return undefined;
    },
};
exports.setLogging = function (log) {
    /* eslint-disable no-console */
    Logging.captureMessage = log ? log.captureMessage : console.log;
    Logging.captureException = log ? log.captureException : console.error;
    Logging.addBreadcrumb = log ? log.addBreadcrumb : console.log;
    Logging.getCorrelationId = log ? log.getCorrelationId : Logging.getCorrelationId;
    Logging.getSessionId = log ? log.getSessionId : Logging.getSessionId;
    Logging.getRelease = log ? log.getRelease : Logging.getRelease;
    Logging.getAppId = log ? log.getAppId : Logging.getAppId;
    Logging.getDeviceId = log ? log.getDeviceId : Logging.getDeviceId;
    Logging.getUserAgent = log ? log.getUserAgent : undefined;
};
exports.default = Logging;
//# sourceMappingURL=index.js.map